import { render } from "./EmptyProductsList.vue?vue&type=template&id=7b1c658e&scoped=true"
import script from "./EmptyProductsList.vue?vue&type=script&lang=js"
export * from "./EmptyProductsList.vue?vue&type=script&lang=js"

import "./EmptyProductsList.vue?vue&type=style&index=0&id=7b1c658e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1c658e"]])

export default __exports__